export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100 scroll-mt-header">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">关于漫蛙漫画</h2>
            <p className="text-foreground-500 text-sm md:text-base">为漫画爱好者打造的一站式免费阅读平台</p>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70">
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              漫蛙漫画网诞生于对漫画的热爱。我们深知每一位漫画爱好者寻找好作品的渴望，
              因此打造了这个汇聚海量<strong className="text-foreground-800">免费韩漫、日漫、国漫</strong>资源的在线阅读平台。
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              从热血冒险到恋爱甜宠，从悬疑推理到奇幻异世界，从古风仙侠到科幻未来——
              无论你喜欢什么类型的漫画，漫蛙漫画网都能满足你的阅读需求。
              我们坚持<strong className="text-foreground-800">高清画质、流畅加载、无广告干扰</strong>的阅读体验，
              让每一页漫画都栩栩如生。
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
              每天都有新的漫画章节更新，每周都有新的作品上架。漫蛙漫画网，让找好看的漫画变得简单。
              我们持续收录<strong className="text-foreground-800">漫画大全</strong>与<strong className="text-foreground-800">漫画全集</strong>，
              打造属于每一个漫画迷的精神家园。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}